/**
 *
 *
 *
 */

export const JM_PAY_TYPE = {
  AUTO_CHARGE: {
    label: '자동충전',
    value: 'AUTO_CHARGE',
    color: 'default',
  },
  OVER_CHARGE: {
    label: '초과충전',
    value: 'OVER_CHARGE',
    color: 'default',
  },
  REFUNDED: {
    label: '환불완료',
    value: 'REFUNDED',
    color: 'magenta',
  },
  USE: {
    label: '주문사용',
    value: 'USE',
    color: 'green',
  },
  CANCELLED: {
    label: '취소신청',
    value: 'CANCELED',
    color: 'volcano',
  },
  MANUAL_CHARGE: {
    label: '수동충전',
    value: 'MANUAL_CHARGE',
    color: 'blue',
  },
  DEDUCTED: {
    label: '금액차감',
    value: 'DEDUCTED',
    color: 'red',
  },
  AMOUNT: {
    label: '전환충전',
    value: 'AMOUNT',
    color: 'purple',
  },
};

export default { JM_PAY_TYPE };
